import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { useUserStore } from '../../lib/userStore';

export default function AppSettings() {
  const userId = useUserStore((s) => s.user_id);
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (Number(userId) !== 3) return;
    let mounted = true;
    setLoading(true);
    (async () => {
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('value')
          .eq('key', 'maintenance_mode')
          .single();

        if (error && (error as any).code !== 'PGRST116') {
          throw error;
        }

        if (!mounted) return;
        setEnabled(Boolean(data?.value?.enabled === true || data?.value?.enabled === 'true'));
      } catch (err: any) {
        console.error('Erreur fetch app_settings:', err);
        setError('Impossible de lire la configuration');
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => { mounted = false; };
  }, [userId]);

  if (Number(userId) !== 3) {
    return <div>Accès refusé.</div>;
  }

  const handleToggle = async () => {
    setSaving(true);
    setError(null);
    try {
      const newValue = !enabled;
      // upsert the key (works even if row was created by migration)
      const { error } = await supabase
        .from('app_settings')
        .upsert({ key: 'maintenance_mode', value: { enabled: newValue }, description: 'Global maintenance flag' }, { onConflict: 'key' });

      if (error) throw error;
      setEnabled(newValue);
    } catch (err: any) {
      console.error('Erreur update app_settings:', err);
      setError('Échec lors de la mise à jour');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Paramètres application</h2>
      <div className="card p-3 mt-3">
        <p>Maintenance globale</p>
        {loading ? (
          <div>Chargement...</div>
        ) : (
          <div>
            <div className="mb-2">Statut: <strong>{enabled ? 'Activée' : 'Désactivée'}</strong></div>
            <button className="btn btn-primary" onClick={handleToggle} disabled={saving}>
              {saving ? 'Enregistrement...' : enabled ? 'Désactiver la maintenance' : 'Activer la maintenance'}
            </button>
            {error && <div className="text-danger mt-2">{error}</div>}
          </div>
        )}
      </div>
    </div>
  );
}
